// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{--bg:#0b1020;--bg2:#0e1428;--card:hsla(0,0%,100%,.06);--card-soft:hsla(0,0%,100%,.04);--stroke:hsla(0,0%,100%,.12);--txt:#e8eefc;--muted:#666;--brand:#009688;--brand-2:#009688;--ok:#009688;--warn:#ff9800;--err:#f44336;--shadow:0 10px 30px rgba(0,0,0,.25);--rad:16px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
